import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  specialty,
  city,
  state,
  totalDoctors,
  doctors = [],
  canonicalUrl
}) => {
  const specialtyName = specialty === 'urologos' ? 'Urólogos' : 
                       specialty === 'pediatras' ? 'Pediatras' : 
                       specialty === 'dermatologos' ? 'Dermatólogos' : 
                       specialty === 'traumatologos' ? 'Traumatólogos' :
                       specialty === 'dentistas' ? 'Dentistas' :
                       specialty === 'otorrinolaringologos' ? 'Otorrinolaringólogos' :
                       specialty === 'nutriologos' ? 'Nutriólogos' :
                       specialty === 'oftalmologos' ? 'Oftalmólogos' :
                       specialty === 'psiquiatras' ? 'Psiquiatras' :
                       specialty === 'cardiologos' ? 'Cardiólogos' :
                       specialty === 'endocrinologos' ? 'Endocrinólogos' :
                       specialty === 'gastroenterologos' ? 'Gastroenterólogos' :
                       specialty === 'cirujanos-plasticos' ? 'Cirujanos Plásticos' :
                       specialty === 'psicologos' ? 'Psicólogos' :
                       specialty === 'podologos' ? 'Podólogos' :
                       specialty === 'reumatologos' ? 'Reumatólogos' :
                       specialty === 'acupuntores' ? 'Acupuntores' :
                       specialty === 'internistas' ? 'Internistas' :
                       specialty === 'geriatras' ? 'Geriatras' :
                       specialty === 'angiologos' ? 'Angiologos' :
                       specialty === 'neurologos' ? 'Neurologos' :
                       specialty === 'homeopatas' ? 'Homeopatas' :
                       specialty === 'alergologos' ? 'Alergologos' :
                       specialty === 'fisioterapeutas' ? 'Fisioterapeutas' :
                       specialty === 'laboratorios-de-analisis-clinicos' ? 'Laboratorios de Análisis Clínicos' :
                       specialty === 'nefrologos' ? 'Nefrologos' :
                       specialty === 'proctologos' ? 'Proctologos' :
                       specialty === 'neumologos' ? 'Neumologos' :
                       specialty === 'medicos-familiares' ? 'Medicos Familiares' :
                       specialty === 'spa-terapeuticos' ? 'Spa Terapéuticos' :
                       specialty === 'farmacias' ? 'Farmacias' :
                       specialty === 'audiologos' ? 'Audiologos' :
                       specialty === 'masajistas' ? 'Masajistas' :
                       specialty === 'tiendas-de-articulos-ortopedicos' ? 'Tiendas de Articulos Ortopédicos' :
                       specialty === 'opticas' ? 'Ópticas' :
                       specialty === 'tiendas-de-sillas-de-ruedas' ? 'Tiendas de Sillas de Ruedas' :
                       specialty === 'radiologos' ? 'Radiologos' :
                       specialty === 'optometristas' ? 'Optometristas' :
                       specialty === 'quiropractico' ? 'Quiropracticos' :
                       specialty === 'periodontistas' ? 'Periodontistas' :
                       specialty === 'esteticistas' ? 'Esteticistas' :
                       'Ginecólogos';

  const singularName = specialty === 'urologos' ? 'Urólogo' : 
                      specialty === 'pediatras' ? 'Pediatra' : 
                      specialty === 'dermatologos' ? 'Dermatólogo' : 
                      specialty === 'traumatologos' ? 'Traumatólogo' :
                      specialty === 'dentistas' ? 'Dentista' :
                      specialty === 'otorrinolaringologos' ? 'Otorrinolaringólogo' :
                      specialty === 'nutriologos' ? 'Nutriólogo' :
                      specialty === 'oftalmologos' ? 'Oftalmólogo' :
                      specialty === 'psiquiatras' ? 'Psiquiatra' :
                      specialty === 'cardiologos' ? 'Cardiólogo' :
                      specialty === 'endocrinologos' ? 'Endocrinólogo' :
                      specialty === 'gastroenterologos' ? 'Gastroenterólogo' :
                      specialty === 'cirujanos-plasticos' ? 'Cirujano Plástico' :
                      specialty === 'psicologos' ? 'Psicólogo' :
                      specialty === 'podologos' ? 'Podólogo' :
                      specialty === 'reumatologos' ? 'Reumatólogo' :
                      specialty === 'acupuntores' ? 'Acupuntor' :
                      specialty === 'internistas' ? 'Internista' :
                      specialty === 'geriatras' ? 'Geriatra' :
                      specialty === 'angiologos' ? 'Angiologo' :
                      specialty === 'neurologos' ? 'Neurologo' :
                      specialty === 'homeopatas' ? 'Homeopata' :
                      specialty === 'alergologos' ? 'Alergologo' :
                      specialty === 'fisioterapeutas' ? 'Fisioterapeuta' :
                      specialty === 'laboratorios-de-analisis-clinicos' ? 'Laboratorio de Análisis Clínicos' :
                      specialty === 'nefrologos' ? 'Nefrologos' :
                      specialty === 'proctologos' ? 'Proctologos' :
                      specialty === 'neumologos' ? 'Neumologos' :
                      specialty === 'medicos-familiares' ? 'Medicos Familiares' :
                      specialty === 'spa-terapeuticos' ? 'Spa Terapéutico' :
                      specialty === 'farmacias' ? 'Farmacias' :
                      specialty === 'audiologos' ? 'Audiologos' :
                      specialty === 'masajistas' ? 'Masajistas' :
                      specialty === 'tiendas-de-articulos-ortopedicos' ? 'Tiendas de Articulos Ortopédicos' :
                      specialty === 'tiendas-de-sillas-de-ruedas' ? 'Tiendas de Sillas de Ruedas' :
                      specialty === 'opticas' ? 'Ópticas' :
                      specialty === 'radiologos' ? 'Radiologos' :
                      specialty === 'optometristas' ? 'Optometristas' :
                      specialty === 'quiropractico' ? 'Quiropracticos' :
                      specialty === 'periodontistas' ? 'Periodontistas' :
                      specialty === 'esteticistas' ? 'Esteticistas' :
                      'Ginecólogo';

  const specialtyData = specialty === 'urologos' ? 'Urología' : 
                       specialty === 'pediatras' ? 'Pediatría' : 
                       specialty === 'dermatologos' ? 'Dermatología' : 
                       specialty === 'traumatologos' ? 'Traumatología' :
                       specialty === 'dentistas' ? 'Dentistas' :
                       specialty === 'otorrinolaringologos' ? 'Otorrinolaringólogos' :
                       specialty === 'nutriologos' ? 'Nutriólogos' :
                       specialty === 'oftalmologos' ? 'Oftalmólogos' :
                       specialty === 'psiquiatras' ? 'Psiquiatras' :
                       specialty === 'cardiologos' ? 'Cardiólogos' :
                       specialty === 'endocrinologos' ? 'Endocrinólogos' :
                       specialty === 'gastroenterologos' ? 'Gastroenterólogos' :
                       specialty === 'cirujanos-plasticos' ? 'Cirujanos Plásticos' :
                       specialty === 'psicologos' ? 'Psicólogos' :
                       specialty === 'podologos' ? 'Podólogos' :
                       specialty === 'reumatologos' ? 'Reumatologo' :
                       specialty === 'acupuntores' ? 'Acupuntores' :
                       specialty === 'internistas' ? 'Internistas' :
                       specialty === 'geriatras' ? 'Geriatras' :
                       specialty === 'angiologos' ? 'Angiologos' :
                       specialty === 'neurologos' ? 'Neurologos' :
                       specialty === 'homeopatas' ? 'Homeopatas' :
                       specialty === 'alergologos' ? 'Alergologos' :
                       specialty === 'fisioterapeutas' ? 'Fisioterapeutas' :
                       specialty === 'laboratorios-de-analisis-clinicos' ? 'Laboratorios de Análisis Clínicos' :
                       specialty === 'nefrologos' ? 'Nefrologos' :
                       specialty === 'proctologos' ? 'Proctologos' :
                       specialty === 'neumologos' ? 'Neumologos' :
                       specialty === 'medicos-familiares' ? 'Medicos Familiares' :
                       specialty === 'spa-terapeuticos' ? 'Spa Terapéuticos' :
                       specialty === 'farmacias' ? 'Farmacias' :
                       specialty === 'audiologos' ? 'Audiologos' :
                       specialty === 'masajistas' ? 'Masajistas' :
                       specialty === 'tiendas-de-articulos-ortopedicos' ? 'Tiendas de Articulos Ortopédicos' :
                       specialty === 'tiendas-de-sillas-de-ruedas' ? 'Tiendas de Sillas de Ruedas' :
                       specialty === 'opticas' ? 'Ópticas' :
                       specialty === 'radiologos' ? 'Radiologos' :
                       specialty === 'optometristas' ? 'Optometristas' :
                       specialty === 'quiropractico' ? 'Quiropracticos' :
                       specialty === 'periodontistas' ? 'Periodontistas' :
                       specialty === 'esteticistas' ? 'Esteticistas' :
                       'Ginecología';
                     

  const generateDoctorsList = () => {
    return doctors.slice(0, 10).map((doctor, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Physician",
        "@id": `https://medicinpro.com/doctor/${doctor._id || doctor.id}`,
        "name": doctor.name,
        "url": `https://medicinpro.com/doctor/${doctor._id || doctor.id}`,
        "address": {
          "@type": "PostalAddress",
          "addressLocality": city,
          "addressRegion": state,
          "addressCountry": "MX",
          "streetAddress": doctor.location?.address || ""
        },
        "medicalSpecialty": specialtyData,
        "workLocation": {
          "@type": "MedicalClinic",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": city,
            "addressRegion": state,
            "addressCountry": "MX",
            "streetAddress": doctor.location?.address || ""
          }
        },
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": canonicalUrl
        }
      }
    }));
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": generateDoctorsList(),
    "numberOfItems": totalDoctors,
    "itemListOrder": "https://schema.org/ItemListOrderAscending",
    "url": canonicalUrl,
    "mainEntity": {
      "@type": "MedicalSpecialty",
      "name": singularName,
      "relevantSpecialty": {
        "@type": "MedicalSpecialty",
        "name": singularName
      }
    }
  };

  return (
    <Helmet>
      <title>{`${totalDoctors} ${specialtyName} (${doctors.filter(d => d.rating?.average >= 4.0).length} altamente calificados) en ${city} | Directorio Médico`}</title>
      <meta name="description" content={`Directorio actualizado de ${totalDoctors} ${specialtyName.toLowerCase()} en ${city}, ${state}. Calificación promedio de ${(doctors.reduce((acc, doc) => acc + (doc.rating?.average || 0), 0) / doctors.length).toFixed(1)}/5 basada en ${doctors.reduce((acc, doc) => acc + (doc.rating?.total_reviews || 0), 0)} opiniones verificadas. Incluye ${doctors.filter(d => d.rating?.average >= 4.0).length} especialistas altamente calificados. Encuentra direcciones, teléfonos y agenda tu cita online.`} />
      <meta name="keywords" content={`${specialtyName}, ${city}, ${state}, doctores, médicos, especialistas, citas médicas, mejores médicos, opiniones médicas verificadas`} />
      
      <link rel="canonical" href={`https://www.medicinpro.com${canonicalUrl}`} />
      
      <meta property="og:title" content={`${totalDoctors} ${specialtyName} en ${city} | Directorio Médico`} />
      <meta property="og:description" content={`Directorio actualizado de ${totalDoctors} ${specialtyName.toLowerCase()} en ${city}, ${state}`} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://www.medicinpro.com${canonicalUrl}`} />
      <meta property="og:site_name" content="Directorio Médico" />
      <meta property="og:locale" content="es_MX" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${totalDoctors} ${specialtyName} en ${city} | Directorio Médico`} />
      <meta name="twitter:description" content={`Directorio actualizado de ${totalDoctors} ${specialtyName.toLowerCase()} en ${city}, ${state}`} />
      
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="theme-color" content="#0ea5e9" />
      <meta name="author" content="Directorio Médico" />
      
      <meta name="geo.region" content={`MX-${state.toLowerCase()}`} />
      <meta name="geo.placename" content={city} />
      
      <meta name="specialty" content={specialtyName} />
      <meta name="city" content={city} />
      <meta name="state" content={state} />
      <meta name="total-doctors" content={totalDoctors} />
      
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO; 